import * as actions from './actions';
import {
    GET_AGREEMENTS,
    GET_CLIENT_POOL_BY_ID,
    SET_AGREEMENTS_LOADING_FALSE,
    SET_BORROWER_AGREEMENTS,
    SET_LENDER_AGREEMENTS,
    SET_CLIENT_POOL_BY_ID,
    SET_POOL_BY_ID_LOADING_FALSE,
    SET_USER_BORROWS,
} from './constants';

import { Agreement, BorrowStatusType, ClientPool, ROLE } from '@/shared/api/borrow';

export type AgreementState = {
    lenderAgreements: Agreement[];
    borrowerAgreements: Agreement[];
    userBorrows: Agreement[];
    selectedAgreement?: ROLE;
    agreementsLoading: boolean;
    clientPool: ClientPool;
    clientPoolLoading: boolean;
};

export const AgreementDefault = {
    id: 0,
    address: '',
    apy: '0',
    icon: '',
    leverageTokenId: 0,
    role: ROLE.OWNER,
    title: '',
    totalDeposited: '',
    description: '',
    collaterals: [''],
    lenders: [''],
    borrowers: [''],
    leverage: {
        id: 0,
        address: '',
        name: '',
        symbol: '',
        balance: '',
        decimals: 0,
    },
    liquidationFee: '',
    liquidationThreshold: '',
    marginCallThreshold: '',
    stressTestMatrix: [{ symbol: '', percent: '', address: '', priceProvider: '', priceModel: '' }],
    totalPosition: '',
    poolBalance: '',
    withdrawable: '',
    interestAccrued: '',
    interestClaimable: '',
    totalBorrowed: '',
    poolUtilization: '0',
    noWalletInfo: false,
    errorContract: false,
    status: BorrowStatusType.OPENED,
    borrowApy: '',
    supplyApy: '',
};

export const ClientPoolDefault: ClientPool = {
    id: 0,
    version: 2,
    address: '',
    apy: '',
    apyHistory: [{ effectiveDate: '', value: '' }],
    icon: '',
    leverageTokenId: 0,
    status: BorrowStatusType.DRAFT,
    title: '',
    stressTestMatrix: [{ symbol: '', percent: '', address: '', priceProvider: '', priceModel: '' }],
    borrowers: [0],
    borrowersWallets: [''],
    collateralTokens: [''],
    description: '',
    lenders: [0],
    lendersWallets: [''],
    leverageToken: '',
    liquidationFee: '',
    liquidationThreshold: '',
    marginCallThreshold: '',
    maxLoanToValue: '',
    totalDepositThreshold: '',
    whitelistedOperators: [''],
    whitelistedTokens: [''],
    withdrawalHaircut: '',
    withdrawalNBlockDelay: 0,
    leverage: {
        id: 0,
        address: '',
        name: '',
        symbol: '',
        decimals: 0,
    },
};

const defaultState: AgreementState = {
    lenderAgreements: [AgreementDefault],
    borrowerAgreements: [AgreementDefault],
    userBorrows: [AgreementDefault],
    agreementsLoading: false,
    clientPool: ClientPoolDefault,
    clientPoolLoading: false,
};

type OrderAction = ReturnType<TInferValueTypes<typeof actions>>;

export default function agreements(state = defaultState, action: OrderAction): AgreementState {
    switch (action.type) {
        case GET_AGREEMENTS: {
            return {
                ...state,
                selectedAgreement: action.payload?.role,
                agreementsLoading: true,
            };
        }

        case SET_LENDER_AGREEMENTS: {
            return {
                ...state,
                lenderAgreements: action.payload,
                agreementsLoading: false,
            };
        }

        case SET_BORROWER_AGREEMENTS: {
            return {
                ...state,
                borrowerAgreements: action.payload,
                agreementsLoading: false,
            };
        }

        case SET_USER_BORROWS: {
            return {
                ...state,
                userBorrows: action.payload,
            };
        }

        case SET_AGREEMENTS_LOADING_FALSE: {
            return {
                ...state,
                agreementsLoading: false,
            };
        }
        case GET_CLIENT_POOL_BY_ID: {
            return {
                ...state,
                clientPoolLoading: true,
            };
        }
        case SET_CLIENT_POOL_BY_ID: {
            return {
                ...state,
                clientPool: action.payload,
                clientPoolLoading: false,
            };
        }
        case SET_POOL_BY_ID_LOADING_FALSE: {
            return {
                ...state,
                clientPoolLoading: false,
            };
        }
        default: {
            return state;
        }
    }
}
